export default __webpack_public_path__ + "static/media/bg-notfound-page.56f150c2.svg";